// Rodolfo Rivas
// 2017
//*************************************************************//
//                                                             //
//    ╔═╗┌─┐┌┬┐┌─┐┌─┐┌┐┌┌─┐┌┐┌┌┬┐┌─┐  ┬ ┬┌─┐┬ ┬┌─┐┬─┐┬┌─┐      //
//    ║  │ ││││├─┘│ ││││├┤ │││ │ ├┤   │ │└─┐│ │├─┤├┬┘││ │      //
//    ╚═╝└─┘┴ ┴┴  └─┘┘└┘└─┘┘└┘ ┴ └─┘  └─┘└─┘└─┘┴ ┴┴└─┴└─┘      //
//                                                             //
//*************************************************************//


import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import "rxjs/Rx";
import { Location } from "@angular/common";
import { UtilConfig } from "../../../../../autenticacion/servicios/UtilConfig";
import { LayoutService } from "../../../../recursos/servicio/layout.service";
import { ConsumerService } from "../../../../recursos/servicio/consumer.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatChipInputEvent } from "@angular/material/chips";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { WebServices } from "../../../../recursos/modelo/consumerModel/web-services.enum";
import { toString } from '../../../../../../pipes/utils/utils';

declare const $: any;
declare var swal: any;


interface FileReaderEventTarget extends EventTarget {
    result: string;
}

interface FileReaderEvent extends Event {
    target: FileReaderEventTarget;

    getMessage(): string;
}

@Component({
    moduleId: module.id,
    selector: 'cmp-form-emisorTerceros',
    templateUrl: './view/form-emisorTerceros.component.html',
    styleUrls: ['./css/form-emisorTerceros.component.scss'],
    providers: [ConsumerService]
})
export class FormEmisorTercerosComponent implements OnInit, AfterViewInit {

    //        ╦┌┐┌┬┌┬┐    ┬ ┬  ╔═╗┌─┐┌┐┌┌─┐┌┬┐┬─┐┬ ┬┌─┐┌┬┐┌─┐┬─┐
    //        ║││││ │     └┬┘  ║  │ ││││└─┐ │ ├┬┘│ ││   │ │ │├┬┘
    //        ╩┘└┘┴ ┴      ┴   ╚═╝└─┘┘└┘└─┘ ┴ ┴└─└─┘└─┘ ┴ └─┘┴└─


    loading = false;
    // VARIABLES DE SEGURIDAD
    authorities = {
        ROLE_FORM_CONF_TERCERO_CONSULTAR: true,
        ROLE_FORM_CONF_TERCERO_MODIFICAR: true,
    };
    // variables de validaciones del formulario
    tablaIGV: any[] = [];
    form: FormGroup;
    vdl_igv: FormControl;
    usuarioSession: any;
    empresaAdmin: any;
    customerThirdsConf: any = {
        approveRequired: "",
        paymentMethod: "",
        paymentTermsDays: 0,
        receiptEmails: "",
        nroColumns: 22,
        currencyName: "",
        currencySymbol: "",
        igv: "",
        processBatchSize: 0,
        processBatchDelay: 0,
        responseBatchSize: 0,
        responseBatchDelay: 0
    };
    customer: any;
    billingConfiguration: any;
    correosReenvio = [];
    removable = true;
    addOnBlur = true;
    separatorKeysCodes = [ENTER, COMMA];
    selectable = true;
    dissabledSave = false;

    constructor(private consumer: ConsumerService,
        private route: ActivatedRoute,
        private router: Router,
        private snackBar: MatSnackBar,
        private fb: FormBuilder,
        private jwtUtil: UtilConfig,
        private _location: Location,
        private layoutService: LayoutService) {

        // VERIFICA LOS PERMISOS DEL EMISOR LOGEADO
        //this.authorities = jwtUtil.verificarAuthorities(this.authorities);
        this.usuarioSession = jwtUtil.getCurrentUser();
        let empresa = this.usuarioSession.customer.id;
        if (empresa.toString() == this.jwtUtil.ESCON_CUSTOMER.toString()) {
            this.empresaAdmin = true;
        }

        this.route.params.subscribe(params => {
            if (params['id']) {
                this.realizarConsultaConfig(params['id']);
            }
        });

    }

    ngOnInit() {
        this.createFormControls();
        this.createForm();
    }

    ngAfterViewInit() {
    }


    //        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┌┐┌┌┬┐┌─┐┬  ┬  ┌─┐
    //        ╠╣ │ │││││  ││ ││││├┤ └─┐  ├─┘├─┤│││ │ ├─┤│  │  ├─┤
    //        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  ┴  ┴ ┴┘└┘ ┴ ┴ ┴┴─┘┴─┘┴ ┴

    createFormControls() {
        this.vdl_igv = new FormControl({ value: "", disabled: (!this.empresaAdmin) }, [
            Validators.required
        ]);
    }

    createForm() {
        this.form = this.fb.group({
            "igv": this.vdl_igv,
        });

    }

    cargando(valor) {
        this.loading = valor;
    }

    backClicked() {
        this._location.back();
    }


    //        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┬─┐┬  ┬┬┌─┐┬┌─┐┌─┐
    //        ╠╣ │ │││││  ││ ││││├┤ └─┐  └─┐├┤ ├┬┘└┐┌┘││  ││ │└─┐ 
    //        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  └─┘└─┘┴└─ └┘ ┴└─┘┴└─┘└─┘ 


    actualizar() {
        this.loading = true;
        let igv = '';
        this.tablaIGV.forEach((value, pos) => {
            if (pos == 0) {
                igv = igv + value;
            } else {
                igv = igv + '|' + value;
            }

        });
        this.customerThirdsConf.igv = igv;
        let correoString = '';
        this.correosReenvio.forEach((value, pos) => {
            if (pos === 0) {
                correoString = correoString + value;
            } else {
                correoString = correoString + ';' + value;
            }
        });
        this.customerThirdsConf.receiptEmails = correoString;

        this.customerThirdsConf.paymentMethod === 'CASH' ?
            this.customerThirdsConf.paymentTermsDays = 0 : false;

        if (this.validateBillingConfiguration() || this.validarFormatoSerie()) {
            this.loading = false;
            return;
        }

        var params = {
            customerThirdsConf: this.customerThirdsConf,
            receptorID: this.customer.id,
            billingConfiguration: this.billingConfiguration,
            ignoreCustomer: true
        }
        // LLAMADO AL SERVICIO
        this.consumer.post(WebServices.URL_UPDATE_CUSTOMER_EMISOR_TERCERO_CONFIG, params)
            .subscribe(result => {
                swal(
                    'Actualizado!',
                    '',
                    'success'
                );
                if (this.empresaAdmin) {
                    this.router.navigate(['/content', { outlets: { 'second': ['configThrids'] } }]);
                } else {
                    this.router.navigate(['/content', { outlets: { 'second': ['home'] } }]);
                }
                this.loading = false;
            }, err => {
                this.loading = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo actualizar el emisor", this.router)
            });
    }

    validateBillingConfiguration(): boolean {
        const serieFactura = this.findValueBillingConfiguration('INVOICE').serialNumber;
        const correlativoFactura =  this.findValueBillingConfiguration('INVOICE').initialValue;

        const serieBoleta = this.findValueBillingConfiguration('TICKET').serialNumber;
        const correlativoBoleta = this.findValueBillingConfiguration('TICKET').initialValue;
        
        const facturaMessage = this.buildMessage(serieFactura, correlativoFactura, 'FACTURA');
        const boletaMessage = this.buildMessage(serieBoleta, correlativoBoleta, 'BOLETA');

        const combinedMessage = facturaMessage && boletaMessage ? (facturaMessage + '<br>' + boletaMessage) : facturaMessage || boletaMessage;

        if (combinedMessage) {
           swal({
                 title: 'Error!',
                 html: combinedMessage,
                 type: 'error'
           });
            return true;
        }
        return false;
    }

    findValueBillingConfiguration(documentType: string): any {
        return this.billingConfiguration.find(x => x.documentType === documentType);
    }

    isEmpty(value: string | null | undefined): boolean {
        return value === null || value === undefined || value === '';
    }

    buildMessage(serie: string, correlativo: string, tipoComprobante: string): string {
    
        if (this.isEmpty(serie) && this.isEmpty(correlativo)) {
           return `-Debe ingresar la serie y el correlativo del comprobante ${tipoComprobante}`;
        }
    
        if (this.isEmpty(serie)) {
            return `-Debe ingresar la serie del comprobante ${tipoComprobante}`;
        }
    
        if (this.isEmpty(correlativo)) {
           return `-Debe ingresar el correlativo del comprobante ${tipoComprobante}`;
        }
    
    }

    deshabilitarBoton(): boolean {
        //return !this.form.valid;
        return false;
    }

    cerrarDetalle() {
        $("ul#slide-out").removeClass("open");
        $("i.cerrarAleta").removeClass("open");
    };

    private realizarConsultaConfig(id) {
        // LLAMADO AL SERVICIO
        this.loading = true;
        this.correosReenvio = [];
        this.consumer.get(WebServices.URL_LIST_CUSTOMER_EMISOR_TERCERO_CONFIG + '/' + id)
            .subscribe(result => {
                this.billingConfiguration = result["billingConfiguration"];
                this.customerThirdsConf = result["customerThirdsConf"];
                this.customer = result["customer"];
                this.customerThirdsConf.receiptEmails.split(';').forEach((value) => {
                    this.correosReenvio.push(value);
                });

                this.tablaIGV = this.customerThirdsConf.igv.split("|");

                this.loading = false;
            }, err => {
                this.loading = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo consultar al emisor", this.router)
            });
    }

    validarEmail(valor) {
        if (/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(valor)) {
            console.log('La dirección de email ' + valor + ' es correcta!.');
            return true;
        } else {
            this.snackBar.open('La dirección de email es incorrecta!.', null, { duration: 2000 });
            return false;
        }
    }

    remove(correo: any): void {
        const index = this.correosReenvio.indexOf(correo);

        if (index >= 0) {
            this.correosReenvio.splice(index, 1);
        }
    }

    add(event: MatChipInputEvent): void {
        const input = event.input;
        const value = event.value;
        // Add our fruit
        if ((value || '').trim() && this.validarEmail(value)) {
            this.correosReenvio.push(value.trim());
        }

        // Reset the input value
        if (input) {
            input.value = '';
        }
    }

    actualizarItem($event, pos) {
        this.tablaIGV[pos] = this.tablaIGV[pos].split(',')[0] + ',' + $event.currentTarget.value;
    }

    changeValue(event: any) :void {
        this.dissabledSave = false;
        let inputValue = event.target.value;

        if (inputValue.toString().length > 8) {
            swal({
                title: 'Error!',
                text: 'El valor del correlativo no debe exceder la cantidad de 8 digitos',
                type: 'error'
            });
            this.dissabledSave = true;
        }    
       
    }

    validarFormatoSerie(): boolean {

        let regExpInovice = new RegExp('[F]{1}[A-Z0-9]{3}');
        let regExpTicket = new RegExp('[B]{1}[A-Z0-9]{3}');

        let message = '';

        if (!regExpInovice.test(this.findValueBillingConfiguration('INVOICE').serialNumber)) {
            message = 'El formato de la serie FACTURA es incorrecto';
        }

        if (!regExpTicket.test(this.findValueBillingConfiguration('TICKET').serialNumber)) {
            message !== '' ? message = message + '<br>' + 'El formato de la serie BOLETA es incorrecto'
             : message = 'El formato de la serie BOLETA es incorrecto';
        }

        swal({
            title: 'Error!',
            html: message,
            type: 'error'
        });

        return message !== '' && message !== undefined;
    }
}




// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/transaccion/emisorTerceros/cmp-form-emisorTerceros/form-emisorTerceros.component.ts